"use strict";
// This interface is the anti corruption layer between kernel and website
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginState = void 0;
/**
 * @public
 */
var LoginState;
(function (LoginState) {
    /**
     * Program not ready.
     */
    LoginState["LOADING"] = "LOADING";
    /**
     * Ready to authenticate
     */
    LoginState["WAITING_PROVIDER"] = "WAITING_PROVIDER";
    LoginState["WAITING_RENDERER"] = "WAITING_RENDERER";
    /**
     * Authenticating
     */
    LoginState["AUTHENTICATING"] = "AUTHENTICATING";
    LoginState["SIGNATURE_PENDING"] = "SIGNATURE_PENDING";
    LoginState["SIGNATURE_FAILED"] = "SIGNATURE_FAILED";
    /**
     * Creating avatar. Before signing ToS
     */
    LoginState["SIGN_UP"] = "SIGN_UP";
    LoginState["WAITING_PROFILE"] = "WAITING_PROFILE";
    LoginState["COMPLETED"] = "COMPLETED";
})(LoginState = exports.LoginState || (exports.LoginState = {}));
//# sourceMappingURL=index.js.map